import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { StyledCashFlowSwapWrapper } from "./styledCashFlowSwap";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import Notification from "../../../elements/notification/Notification";
import { Helmet } from "react-helmet-async";
import MaterialPagination from "../../../styles/materialPagination";
import CashFlowSwapList from "./CashFlowSwapList";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import CashFlowSwapFilter from "./CashFlowSwapFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";

const CashFlowSwapContainer = () => {
  const { t } = useTranslation("cashFlow");
  const [swaps, setSwaps] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "swap", false, true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "status.value": checkFilterItem(history, "status.value", null),
    "id": checkFilterItem(history, "id", null),
    "referenceId": checkFilterItem(history, "referenceId", null),
    "note": checkFilterItem(history, "note", null),
    "inConnection.project.user.email": checkFilterItem(history, "inConnection.project.user.email", null),
    "inConnection.project.name": checkFilterItem(history, "inConnection.project.name", null),
    "inConnection.service.name": checkFilterItem(history, "inConnection.service.name", null),
    "inPaymentSystem.subName": checkFilterItem(history, "inPaymentSystem.subName", null),
    "inCurrency.asset": checkFilterItem(history, "inCurrency.asset", null),
    "outConnection.service.name": checkFilterItem(history, "outConnection.service.name", null),
    "outPaymentSystem.subName": checkFilterItem(history, "outPaymentSystem.subName", null),
    "outCurrency.asset": checkFilterItem(history, "outCurrency.asset", null),
    "inAmount[gte]": checkFilterItem(history, "inAmount[gte]", null, true),
    "inAmount[lte]": checkFilterItem(history, "inAmount[lte]", null, true),
    "outAmount[gte]": checkFilterItem(history, "outAmount[gte]", null, true),
    "outAmount[lte]": checkFilterItem(history, "outAmount[lte]", null, true),
    "updatedAt[gte]": checkFilterItem(history, "updatedAt[gte]", null, true),
    "updatedAt[lte]": checkFilterItem(history, "updatedAt[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchSwap = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/swaps" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setSwaps(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchSwap();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledCashFlowSwapWrapper>
        <Helmet>
          <title>{t("swap.meta.title")}</title>
        </Helmet>
        <div className="swap-head">
          <CashFlowSwapFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <CashFlowSwapList
          swaps={swaps}
          notification={notification}
          setNotification={setNotification}
        />
        {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledCashFlowSwapWrapper>
    </>
  );
};

export default CashFlowSwapContainer;